/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_DescriptionInputs */

const en_to_xml_description = /** @type {(inputs: To_Xml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert JSON to XML format online. Transform your JSON data into well-formed XML documents.`)
};

const ko_to_xml_description = /** @type {(inputs: To_Xml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 XML 형식으로 온라인 변환하세요. JSON 데이터를 올바른 XML 문서로 변환합니다.`)
};

const ja_to_xml_description = /** @type {(inputs: To_Xml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONをXML形式にオンライン変換。JSONデータを整形式のXMLドキュメントに変換します。`)
};

/**
* | output |
* | --- |
* | "Convert JSON to XML format online. Transform your JSON data into well-formed XML documents." |
*
* @param {To_Xml_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_description = /** @type {((inputs?: To_Xml_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_description(inputs)
	if (locale === "ko") return ko_to_xml_description(inputs)
	return ja_to_xml_description(inputs)
});